import PropTypes from 'prop-types';

export default function MetaLabels({ children, className }) {
    if (! Array.isArray(children)) {
        if (children.type.displayName === 'MetaLabel') {
            return (
                <div
                    className={`esc-ii-flex esc-ii-items-center esc-ii-mt-4${
                        className ? ' ' + className : ''
                    }`}
                >
                    {children}
                </div>
            );
        }
        return <></>
    }
    const actualChildren = children.filter(child => child.type.displayName === 'MetaLabel');
    return (
        <div
            className={`esc-ii-flex esc-ii-items-center esc-ii-mt-4${
                className ? ' ' + className : ''
            }`}
        >
            {actualChildren.map((child, index) => (
                <>
                    {index > 0 && (
                        <span className="esc-ii-w-1.5 esc-ii-h-1.5 esc-ii-bg-black esc-ii-block esc-ii-rounded-full esc-ii-mx-5"></span>
                    )}
                    {child}
                </>
            ))}
        </div>
    );
}

MetaLabels.propTypes = {
    className: PropTypes.string,
};

MetaLabels.displayName = 'MetaLabels';
